import React from 'react';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const SvgIcon = (props: SvgIconT.Props) => {
  const { containerProps = {}, size, color, className = '', style = {}, innerRef, ...rest } = props;
  const fill = !color && !props.fill ? '#FFF' : props.fill;
  const width = !size && !props.width ? 77 : props.width;
  const height = !size && !props.height ? 28 : props.height;
  const { cssClassName } = convertPropToCssClassName('icon', className, {
    size,
    color,
  });
  return (
    <span
      ref={innerRef}
      className={cssClassName}
      {...rest}
      {...containerProps}
      style={
        {
          width,
          height,
          ...style,
        } as React.CSSProperties
      }
    >
      <svg
        width={width && String(width)}
        height={height && String(height)}
        style={{
          width,
          height,
        }}
        fill={fill}
        viewBox="0 0 77 28"
      >
        <defs>
          <filter colorInterpolationFilters="auto" id="a">
            <feColorMatrix
              in="SourceGraphic"
              values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
            />
          </filter>
        </defs>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(33.723508 5.273548)" filter="url(#a)">
            <path
              d="M40.0053246.56069132V3.1868971h-.2679332V.30747588h.4305035l.9562319 2.57918007.9486284-2.57918007H42.5v2.88303859h-.2682953V.56069132l-.9775941 2.62620579h-.2715539l-.9772321-2.6262058zM37.1916638.55345659V.3074759h2.2090007v.2459807h-.9707148v2.63344052h-.2679332V.55345659h-.9703527zM30.696456 13.1346463l1.017422-.9907958 1.4772534 1.500844c.901559-1.2226688 1.4338047-2.8830386 1.4338047-4.98472665 0-4.59405145-2.5891762-7.17684888-6.0288593-7.17684888-3.439683 0-6.0281351 2.58641479-6.0281351 7.17684888 0 4.59405145 2.5848313 7.19855305 6.0281351 7.19855305 1.3617525-.0036174 2.6105385-.4159968 3.6026155-1.2009646l-1.5022363-1.52291zm5.8691855 3.8741961L35.5478574 18l-2.2158801-2.2138264c-1.249148.9911576-2.8419023 1.5446142-4.7359005 1.5446142-4.7572627 0-7.6683208-3.5775724-7.6683208-8.67805468C20.927756 3.5522508 23.8388141 0 28.5960768 0c4.7579869 0 7.669045 3.5522508 7.669045 8.65273312 0 2.49236338-.6915573 4.59405148-1.9407054 6.11696138l2.2412251 2.2391479zm-20.0949906.0253216h1.546047V.30385852h-1.546047V17.034164zm-5.8221162-5.6322347L7.18350656 2.21744373 3.76554779 11.4019293h6.88298691zM8.10642784.30385852L14.4828761 17.034164h-1.687255l-1.5934785-4.1997589H3.23294002L1.66191004 17.034164H0L6.35074118.30385852h1.75568666z"
              fill="#353C46"
            />
          </g>
          <path
            d="M9.826875 19.7825c-.148125 0-.298125.016875-.45.0525-1.04625.2476875-1.696875 1.30125-1.449375 2.3475.2475 1.04625 1.30125 1.6970625 2.3475 1.449375.50625-.1198125.9375-.43125 1.21125-.87375.27375-.444375.358125-.9675.238125-1.47375-.211875-.89625-1.014375-1.501875-1.8975-1.501875zM20.8575 18.41375c-.3525.084375-.706875.12375-1.05375.12375-1.985625 0-3.7933125-1.305-4.38-3.264375H4.561875L0 24.39875V26h8.188125C6.825 25.475 5.73375 24.3125 5.37375 22.788125c-.58125-2.454375.943125-4.925625 3.3975-5.506875 2.45625-.5810625 4.925625.943125 5.506875 3.3975.28125 1.18875.0825 2.416875-.55875 3.4575-.5325.864375-1.321875 1.5075-2.25375 1.86375H24V15.779375c-.555 1.27875-1.685625 2.289375-3.1425 2.634375zM5.445 4.955C5.844375 3.63125 6.8325 2.519375 8.173125 2H0v2.955h5.445zm2.4825 1.760625C8.175 7.761875 9.22875 8.4125 10.275 8.165c.50625-.12.9375-.43125 1.21125-.87375.27375-.4425.358125-.9675.238125-1.47375-.12-.50625-.429375-.9375-.87375-1.21125-.31125-.193125-.66375-.290625-1.02-.290625-.15 0-.301875.016875-.45375.0525-1.04625.2475-1.696875 1.30125-1.449375 2.3475zm4.30125-4.3425c1.0404375.64125 1.768125 1.65 2.049375 2.840625.28125 1.18875.0825 2.416875-.55875 3.4575s-1.65 1.768125-2.840625 2.049375c-.3525.084375-.706875.12375-1.05375.12375-1.985625 0-3.793125-1.305-4.38-3.264375H0v10.95l2.94-5.88h12.481875c.455625-1.513125 1.681875-2.750625 3.32625-3.140625 1.18875-.28125 2.416875-.0825 3.4575.55875.81.49875 1.426875 1.2225 1.794375 2.079375V2H11.47875c.25875.10125.51.225.75.373125zm8.59875 9.928125c-.31125-.193125-.66375-.290625-1.0201875-.290625-.1498125 0-.3016875.016875-.4535625.0525-1.0464375.2475-1.696875 1.30125-1.449375 2.3476875.2473125 1.0460625 1.30125 1.695 2.3475 1.4491875.50625-.12.9375-.43125 1.21125-.87375.27375-.444375.358125-.9675.238125-1.47375-.1201875-.50625-.43125-.9375-.87375-1.21125z"
            fill="#FFF"
          />
        </g>
      </svg>
    </span>
  );
};

export default SvgIcon;
